export const SPSS_VERSION = '31.0'; //'29.0.2';
export const PSIMAGOPRO_VERSION = '11.0';

export const SpecialDiscountNameDE = 'Winterrabatt';
export const SpecialDiscountNameEN = 'Winter Discoun';
export const SpecialDiscountPercentage = 0;

export type LicenseType =
  | 'authorized perpetual'
  | 'concurrent perpetual'
  | 'authorized fixed term'
  | 'concurrent fixed term';

export type moduleStructure = {
  name: string;
  variations: { lic_type: LicenseType; sku: string; IBM_price: number; PS_Imago_Price: number }[];
};

// ===================================================================================================
// SPSS Modules
// ===================================================================================================

const IBM_StdModulePrice_Authorized_Perpetual = 2570; //2447;
const PS_StdModulePrice_Authorized_Perpetual = 1040; //990; /*EK: 323*3 */
const IBM_StdModulePrice_Concurrent_Perpetual = 6440; //6133;
const PS_StdModulePrice_Concurrent_Perpetual = 2583; //2460; /*EK: 821*3 */

const IBM_StdModulePrice_Authorized_Fixed = 509; //485;
const PS_StdModulePrice_Authorized_Fixed = 305; //290; /*EK: 144*2 */
const IBM_StdModulePrice_Concurrent_Fixed = 1275; //1214;
const PS_StdModulePrice_Concurrent_Fixed = 766; //730; /*EK: 363*2 */

export const spssmodules: moduleStructure[] = [
  {
    name: 'PS Desktop',
    variations: [
      { lic_type: 'authorized perpetual', sku: 'PSDPPAD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'concurrent perpetual', sku: 'PSDPPCD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'authorized fixed term', sku: 'PSDPFAD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'concurrent fixed term', sku: 'PSDPFCD', IBM_price: 0, PS_Imago_Price: 0 },
    ],
  },
  {
    name: 'PS IMAGO Pack PRO',
    variations: [
      { lic_type: 'authorized perpetual', sku: 'PSPOPAD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'concurrent perpetual', sku: 'PSPOPCD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'authorized fixed term', sku: 'PSPOFAD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'concurrent fixed term', sku: 'PSPOFCD', IBM_price: 0, PS_Imago_Price: 0 },
    ],
  },
  {
    name: 'PS IMAGO Designer',
    variations: [
      { lic_type: 'authorized perpetual', sku: 'PSDRPAD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'concurrent perpetual', sku: 'PSDRPCD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'authorized fixed term', sku: 'PSDRFAD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'concurrent fixed term', sku: 'PSDRFCD', IBM_price: 0, PS_Imago_Price: 0 },
    ],
  },
  {
    name: 'PS IMAGO Process',
    variations: [
      { lic_type: 'authorized perpetual', sku: 'PSPSPAD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'concurrent perpetual', sku: 'PSPSPCD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'authorized fixed term', sku: 'PSPSFAD', IBM_price: 0, PS_Imago_Price: 0 },
      { lic_type: 'concurrent fixed term', sku: 'PSPSFCD', IBM_price: 0, PS_Imago_Price: 0 },
    ],
  },

  {
    name: 'IBM SPSS Base Statistics',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EJ9LL',
        IBM_price: 4415,
        PS_Imago_Price: 2405, //2290 /*EK: 757*3 */,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0ELQLL',
        IBM_price: 10984,
        PS_Imago_Price: 5954, //5670 /*EK: 1885*3 */,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09NNLL',
        IBM_price: 882,
        PS_Imago_Price: 646, //615 /*EK:331 */,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09PWLL',
        IBM_price: 2197,
        PS_Imago_Price: 1612, //1535 /*EK: 830 */,
      },
    ],
  },

  {
    name: 'IBM SPSS Data Preparation',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: '',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0ELYLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09PZLL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09Q0LL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Bootstrapping',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0ELJLL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0ELHLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09PTLL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09PSLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Advanced Statistics',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0ELNLL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0ELLLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09PVLL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09PULL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Regression',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EL3LL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EL1LL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09PKLL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09PJLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Custom Tables',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0ELSLL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0ELULL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09PXLL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09PYLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Decision Trees',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EMMLL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EMKLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09QCLL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09QBLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Forecasting',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EMCLL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EM8LL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09Q7LL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09Q5LL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Missing Values',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EM6LL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EM4LL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09Q4LL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09Q3LL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Categories',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0ELFLL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0ELDLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09PRLL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09PQLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Exact Tests',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EMELL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EMPLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09Q8LL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09QDLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Direct Marketing',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EMILL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EMGLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09QALL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09Q9LL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Neural Networks',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EM2LL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EM0LL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09Q2LL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09Q1LL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Complex Samples',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0ELBLL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EL9LL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09PPLL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09PNLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Conjoint',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EL7LL',
        IBM_price: IBM_StdModulePrice_Authorized_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Perpetual,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EL5LL',
        IBM_price: IBM_StdModulePrice_Concurrent_Perpetual,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Perpetual,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09PMLL',
        IBM_price: IBM_StdModulePrice_Authorized_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Authorized_Fixed,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09PLLL',
        IBM_price: IBM_StdModulePrice_Concurrent_Fixed,
        PS_Imago_Price: PS_StdModulePrice_Concurrent_Fixed,
      },
    ],
  },
  {
    name: 'IBM SPSS Amos',
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0ENHLL',
        IBM_price: 2925.0,
        PS_Imago_Price: 1250, //1190 /*EK: 392*3 */,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0ENFLL',
        IBM_price: 7341.0,
        PS_Imago_Price: 3140, //2990 /*EK: 983*3 */,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09QSLL',
        IBM_price: 584.0,
        PS_Imago_Price: 365, //347 /* EK:173*2 */,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09QRLL',
        IBM_price: 1478.0,
        PS_Imago_Price: 935, //890 /* EK:432*2 */,
      },
    ],
  },
];

// ===================================================================================================
// SPSS Bundles
// ===================================================================================================

export const spssbundles: (moduleStructure & { includedModules: string[] })[] = [
  {
    name: 'IBM SPSS Base',
    includedModules: [
      'PS Desktop',
      'PS IMAGO Pack PRO',
      'PS IMAGO Designer',
      'PS IMAGO Process',
      'IBM SPSS Base Statistics',
      'IBM SPSS Data Preparation',
      'IBM SPSS Bootstrapping',
    ],

    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EJ9LL',
        IBM_price: 4415,
        PS_Imago_Price: 2405, //2290 /*EK: 757*3 */,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0ELQLL',
        IBM_price: 10984,
        PS_Imago_Price: 5954, //5670 /*EK 1885*/,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09NNLL',
        IBM_price: 882,
        PS_Imago_Price: 646, //615 /*EK:331 */,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09PWLL',
        IBM_price: 2197,
        PS_Imago_Price: 1612, //1535 /*EK: 830 */,
      },
    ],
  },
  {
    //PS Desktop + PS IMAGO Pack PRO + PS IMAGO Designer + PS IMAGO Process +
    name: 'IBM SPSS Standard',
    includedModules: [
      'PS Desktop',
      'PS IMAGO Pack PRO',
      'PS IMAGO Designer',
      'PS IMAGO Process',
      'IBM SPSS Base Statistics',
      'IBM SPSS Data Preparation',
      'IBM SPSS Bootstrapping',
      'IBM SPSS Advanced Statistics',
      'IBM SPSS Custom Tables',
      'IBM SPSS Regression',
    ],
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EKZLL',
        IBM_price: 9734.0,
        PS_Imago_Price: 4715, //4490 /*EK: 1470*3 */,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EK0LL',
        IBM_price: 24362.0,
        PS_Imago_Price: 11540, //10990 /*EK: 3677 * 3 */,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09PILL',
        IBM_price: 1947.0,
        PS_Imago_Price: 1355, //1290 /*EK: 645*2 */,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09P1LL',
        IBM_price: 4829.0,
        PS_Imago_Price: 3550, //3380 /*EK: 1615 */,
      },
    ],
  },
  {
    name: 'IBM SPSS Professional',
    includedModules: [
      'PS Desktop',
      'PS IMAGO Pack PRO',
      'PS IMAGO Designer',
      'PS IMAGO Process',
      'IBM SPSS Base Statistics',
      'IBM SPSS Data Preparation',
      'IBM SPSS Bootstrapping',
      'IBM SPSS Advanced Statistics',
      'IBM SPSS Custom Tables',
      'IBM SPSS Regression',
      'IBM SPSS Decision Trees',
      'IBM SPSS Forecasting',
      'IBM SPSS Missing Values',
      'IBM SPSS Categories',
    ],
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EJWLL',
        IBM_price: 19467.0,
        PS_Imago_Price: 8810, //8390 /*EK: 2773 * 3 */,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EJSLL',
        IBM_price: 48615.0,
        PS_Imago_Price: 22040, //20990 /*EK: 6925 * 3 */,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09NZLL',
        IBM_price: 3882.0,
        PS_Imago_Price: 2573, //2450 /*EK: 1223*2 */,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09NXLL',
        IBM_price: 9777.0,
        PS_Imago_Price: 6510, //6200 /*EK: 3046*2 */,
      },
    ],
  },
  {
    name: 'IBM SPSS Premium',
    includedModules: [
      'PS Desktop',
      'PS IMAGO Pack PRO',
      'PS IMAGO Designer',
      'PS IMAGO Process',
      'IBM SPSS Base Statistics',
      'IBM SPSS Data Preparation',
      'IBM SPSS Bootstrapping',
      'IBM SPSS Advanced Statistics',
      'IBM SPSS Custom Tables',
      'IBM SPSS Regression',
      'IBM SPSS Decision Trees',
      'IBM SPSS Forecasting',
      'IBM SPSS Missing Values',
      'IBM SPSS Categories',
      'IBM SPSS Exact Tests',
      'IBM SPSS Direct Marketing',
      'IBM SPSS Neural Networks',
      'IBM SPSS Complex Samples',
      'IBM SPSS Conjoint',
      'IBM SPSS Amos',
    ],
    variations: [
      {
        lic_type: 'authorized perpetual',
        sku: 'D0EJNLL',
        IBM_price: 29039.0,
        PS_Imago_Price: 13115, //12490 /*EK: 4055 * 3 */,
      },
      {
        lic_type: 'concurrent perpetual',
        sku: 'D0EJJLL',
        IBM_price: 72761.0,
        PS_Imago_Price: 32015, //30490 /*EK: 10159 * 3 */,
      },
      {
        lic_type: 'authorized fixed term',
        sku: 'E09NVLL',
        IBM_price: 5818.0,
        PS_Imago_Price: 3770, //3590 /*EK: 1791*2 */,
      },
      {
        lic_type: 'concurrent fixed term',
        sku: 'E09NTLL',
        IBM_price: 14573.0,
        PS_Imago_Price: 9440, //8990 /*EK: 4486*2 */,
      },
    ],
  },
];
